import { registerBars } from "./bars.js";
import { registerContainers } from "./containers.js";
import { registerInputs } from "./inputs.js";
import { registerArtElements } from "./art.js";
import { registerSceneElements } from "./scene.js";

let registered = false;

/**
 * Put the core controls in the registry.
 *
 * Called from the loader rather than run as a side effect of importing the barrel, so importing
 * a type from this extension does not quietly register forty elements — and so a test can reason
 * about a registry that is empty until something asks for one.
 */
export function registerCoreElements(): void {
  if (registered) return;
  registered = true;
  registerContainers();
  registerInputs();
  registerBars();
  registerSceneElements();
  registerArtElements();
}
